import styles from '@components/TopbarNew/Topbar.module.scss'
import { BREAKPOINT } from '@constants/breakpoints'
import { useAcl } from '@contexts/acl'
import { useFeatureFlags } from '@contexts/featureFlags'
import { useUserContext } from '@contexts/user'
import { useBreakpoint } from '@hooks/useBreakpoint'
import { useShouldSeeItem } from '@hooks/useShouldSeeItem'
import { useStyles } from '@hooks/useStyles'
import { Row } from 'simple-flexbox'

import { NewInterfaceBanner } from './NewInterfaceBanner'

export const useGetBanner = () => {
  const { createdAt } = useUserContext()

  const hasAccessToPlatformDevelopment = useFeatureFlags('PLATFORM_DEVELOPMENT')

  const sholudShowPromoBannerACL = useAcl('top_bar.promo_banner.view')

  const isLowerThan1130 = useBreakpoint(BREAKPOINT[1130], 'max')

  const isLowerThan1350 = useBreakpoint(BREAKPOINT[1350], 'max')

  const RELEASE_DATE = '2025-03-13'

  const shouldSeeNewInterfaceBanner = useShouldSeeItem({
    referenceDate: createdAt?.formatted,
    targetDate: RELEASE_DATE
  })

  const bannerStyles = useStyles({
    [styles.banner]: !isLowerThan1350,
    [styles['banner__lower-than-desktop']]: isLowerThan1350
  })

  // Add here all new banners
  const getBanner = () => {
    if (shouldSeeNewInterfaceBanner && hasAccessToPlatformDevelopment) {
      return <NewInterfaceBanner />
    }

    return null
  }

  const isAnyBannerToRender = getBanner() !== null

  if (isLowerThan1130 || !sholudShowPromoBannerACL || !isAnyBannerToRender) {
    return null
  }

  return <Row className={bannerStyles}>{getBanner()}</Row>
}
